import TableDetailsPanel from "@/components/TableDetailsPanel";
import { Row } from "@tanstack/react-table";
import { PersonEventRegistration } from "../types";
import { sortBy } from "lodash";

export const ExpandedRegistrationRow = ({
  row,
  columnDefsSessions
}: {
  row: Row<PersonEventRegistration>;
  columnDefsSessions: any;
}) => {
  const sortedSessions = sortBy(row.original.sessions, "startsAt", "asc");

  return (
    <TableDetailsPanel
      data={sortedSessions || []}
      columns={columnDefsSessions}
      title={`Sessions (${sortedSessions.length})`}
    />
  );
};
